module.exports = __webpack_public_path__ + "img/member-11.be480a78.png";